export default __webpack_public_path__ + "static/media/63-min.d99e2bd5.png";